<script setup>
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import completionImage from 'dashboard/assets/real-estate/nucleo-work-order-request/concluir-processo-2.png';

defineProps({
  saving: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();
</script>

<template>
  <LaisModal
    :show="show"
    max-width-class="max-w-[1040px]"
    header-class="absolute right-2 top-2 z-10 !border-0 !p-0"
    @close="emit('close')"
  >
    <template #header>
      <span class="sr-only">
        {{ t('NUCLEO_WORK_ORDERS.REQUEST.DIALOG.TITLE') }}
      </span>
    </template>
    <div
      class="-m-4 grid overflow-hidden sm:-mx-6 sm:-my-5 md:grid-cols-[482px_minmax(0,1fr)] md:gap-x-[43px]"
    >
      <img
        data-testid="nucleo-work-order-request-dialog-image"
        :src="completionImage"
        :alt="t('NUCLEO_WORK_ORDERS.REQUEST.DIALOG.HEADING')"
        class="h-auto w-full object-cover md:w-[482px]"
      />
      <div
        class="flex min-w-0 flex-col justify-between gap-8 px-5 py-8 sm:px-8 sm:py-10 md:pb-[57px] md:pl-0 md:pr-[59px] md:pt-[31px]"
      >
        <div>
          <h3
            class="max-w-[385px] font-redHatDisplay text-2xl font-bold leading-8 text-lais-text md:text-[32px] md:leading-9"
          >
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.DIALOG.HEADING') }}
          </h3>
          <p
            class="mt-[25px] max-w-[442px] text-base leading-6 text-lais-text-body md:text-xl md:leading-6"
          >
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.DIALOG.DESCRIPTION') }}
          </p>
        </div>
        <div class="flex flex-wrap justify-end gap-5">
          <LaisPrimaryButton variant="ghost" @click="emit('close')">
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.ACTIONS.BACK') }}
          </LaisPrimaryButton>
          <LaisPrimaryButton
            icon="i-lucide-check"
            :is-loading="saving"
            @click="emit('submit')"
          >
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.ACTIONS.CONFIRM') }}
          </LaisPrimaryButton>
        </div>
      </div>
    </div>
  </LaisModal>
</template>
